import { render, staticRenderFns } from "./KBButton.vue?vue&type=template&id=648a99a5&scoped=true&"
import script from "./KBButton.vue?vue&type=script&lang=js&"
export * from "./KBButton.vue?vue&type=script&lang=js&"
import style0 from "./KBButton.vue?vue&type=style&index=0&id=648a99a5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648a99a5",
  null
  
)

export default component.exports